export default "{{ 'tc-grid.no-rows' | translate }}\r\n";